// extracted by mini-css-extract-plugin
module.exports = {"RecommendBox":"recommend-box_RecommendBox__2SZ_L"};